(function (app, ng) {

    app.config([
        "$stateProvider", function ($stateProvider) {
            $stateProvider.state("Home.Resources.RetireUp",
                {
                    url: "/RetireUp",
                    component: "retireup",
                    PageTitle: "RetireUpPro",
                    requiredPermissions: "RetireUp:View",
                    resolve: {
                        states: ["states", function (states) {
                            return states;
                        }]
                    }
                });
        }
    ]);

    app.component("retireup",
        {
            templateUrl: "App/Resources/RetireUp/RetireUp.html",
            controller: biCtrl,
            bindings: {
                states: "<"
            }
        });

    biCtrl.$inject = ["ssoApi", "eligibilityFormApi", "eligibilityFormDialog", "surveys", "permissionService", "purchaseApi", "$mdDialog", "userApi", "$interval", "externalLoading", "amplitudeService", "surveyRenewalDialog"];
    function biCtrl(ssoApi, eligibilityFormApi, eligibilityFormDialog, surveys, permissionService, purchaseApi, $mdDialog, userApi, $interval, externalLoading, amplitudeService, surveyRenewalDialog) {
        var $ctrl = this;

        ng.extend($ctrl,
            {
                loading: true,
                intervals: [],               
                purchased: null,
                submitted: null,
                pendingRenewal: false,
                hasPastRenewals: false,
                surveyId: null,
                openSurveyRenewalDialog: openSurveyRenewalDialog,
                getAndRefreshSurveyRenewals: getAndRefreshSurveyRenewals,
                verifyPurchased: verifyPurchased,
                activateRetireUpSso: activateRetireUpSso,
                openDialog: openDialog,
                openPurchaseDialog: openPurchaseDialog,
                logAmplitude: logAmplitude,
                init: init
            });

        function init() {
            surveys.then(function (s) {
                $ctrl.surveyId = s.retireUpId;

                $ctrl.getAndRefreshSurveyRenewals().then(function () {
                    if ($ctrl.pendingRenewal)
                        $ctrl.openSurveyRenewalDialog();
                });

                eligibilityFormApi.isEnrolled($ctrl.surveyId).then(function (response) {
                    $ctrl.submitted = response;
                });
            }).then($ctrl.verifyPurchased).then(function () { $ctrl.loading = false; });
        }

        function openSurveyRenewalDialog() {
            surveyRenewalDialog.open(event, $ctrl.surveyRenewals, $ctrl.surveyId).then(function (obj) {
                ng.extend($ctrl, obj);
            }).then(function () {
                $ctrl.verifyPurchased();
                $ctrl.getAndRefreshSurveyRenewals();
            });
        }

        function getAndRefreshSurveyRenewals() {
           
            return eligibilityFormApi.getSurveyRenewals($ctrl.surveyId).then(function (results) {
                $ctrl.surveyRenewals = results;
                var renewal = _.find(results, function (renewal) { return renewal.SurveyId === $ctrl.surveyId; });
                if (renewal) {                   
                    if (renewal.SurveyRenewalStatusId === 1) {
                        $ctrl.pendingRenewal = true;
                    }
                    else {
                        $ctrl.pendingRenewal = false;
                        $ctrl.hasPastRenewals = true;
                    }
                }

            }, function () {
                return null;
            });
        }

        function verifyPurchased() {
            if (!$ctrl.hasPastRenewals) {
                return userApi.getLoggedInUser().then(function (user) {
                    return purchaseApi.getUserOrders(user.Id).then(function (orders) {
                                              
                        $ctrl.hasPastRenewals = _.some(orders, function (o) { return o.MarketingStrategy === "RetireUp" && o.ArcSurveyRenewalId !== null; });                                                  
                        $ctrl.purchased = _.find(orders, function (o) { return o.MarketingStrategy === "RetireUp" && o.ArcSurveyRenewalId === null; });
                      
                        if ($ctrl.purchased) {
                            var d = new Date($ctrl.purchased.CompletedDate);
                            var n = d.toLocaleDateString();
                            $ctrl.purchased.PurchaseDate = n;

                            purchaseApi.getMarketingStrategyOfOrder($ctrl.purchased.Id).then(function (strategy) {
                                if (strategy.DocusignUrl !== null)
                                    $ctrl.purchased.DocusignUrl = strategy.DocusignUrl;

                                if (strategy.Image !== null)
                                    $ctrl.purchased.Image = strategy.Image;
                            });

                            ng.forEach($ctrl.intervals, function (interval) {
                                $interval.cancel(interval);
                            });
                        }                                                                                                                                                     
                    });
                });
            }
        }

        function activateRetireUpSso() {
            if (permissionService.hasOnePermission("RetireUp:Access")) {
                var w = window.open();
                w.document.write(externalLoading.html);
                ssoApi.initiateRetireUpSso().then(function (data) {
                    w.document.write(data);
                    w.document.forms.samlform.submit();
                },
                    function (error) {
                        console.log(error);
                        w.document.write(" Failed.  There was an error accessing this resource.");
                    });
            }
        };

        /*  Open the Enrollment Form  */
        function openDialog(event) {
            surveys.then(function (s) {
                eligibilityFormDialog.open(event, s.retireUpId).then(function (obj) {
                    ng.extend($ctrl, obj);
                });
            });
        }

        function openPurchaseDialog(event) {

            $mdDialog.show({
                bindToController: true,
                controllerAs: "$ctrl",
                controller: dialogCtrl,
                templateUrl: "App/Resources/PurchasePage/template.html",
                parent: ng.element(document.body),
                targetEvent: event,
                clickOutsideToClose: false,
                locals: {
                    purchased: false,
                    orders: purchaseApi.getAllOrders(),
                    title: "RetireUp Pro",
                    //purchaseOptions: [{ Description: "RetireUp Pro - Monthly Recurring Payments", Amount: 99, IsRecurringPayment: true }],
                    purchaseOptions: [{ Description: "RetireUp Pro - One Time Payment", Amount: 1000, IsRecurringPayment: false }],
                    termsLink: "https://www.figmarketing.com/Documents/Terms_of_Use.pdf",
                    marketingDollars: purchaseApi.getMarketingDollars().then(function (response) {
                        return response.MarketingDollarsTotal;
                    }).catch(ng.noop)
                }
            }).then(function (paymentAmount) {
                if (paymentAmount > 0) {
                    //TODO: AP - Lets come up with a better way to verify the purchase after paytrace executed

                    $ctrl.intervals.push(
                        $interval(function () {
                            $ctrl.verifyPurchased();
                        }, 3000)
                    );
                }
                else $ctrl.verifyPurchased();
            }).then(function () { $ctrl.loading = false; });
        }

        function logAmplitude(propertyName) {
            return amplitudeService.logClickEvent(propertyName);
        }

        $ctrl.init();
    }

    dialogCtrl.$inject = ["$mdDialog", "purchaseApi", "$window"];
    function dialogCtrl($mdDialog, purchaseApi, $window) {
        var $ctrl = this;

        ng.extend($ctrl,
            {
                close: close,
                cancel: cancel,
                purchase: purchase,
                getPaymentAmount: getPaymentAmount,
                setup: setup
            });

        function setup() {
            $ctrl.selectedPurchaseOption = 0;
            $ctrl.paymentAmount = $ctrl.purchaseOptions[0].Amount;
            $ctrl.marketingDollarsToUse = 0;
        }

        $ctrl.setup();

        function getPaymentAmount() {
            if ($ctrl.marketingDollarsToUse > $ctrl.marketingDollars) {
                $ctrl.marketingDollarsToUse = $ctrl.marketingDollars;
            }
            if ($ctrl.marketingDollarsToUse > $ctrl.purchaseOptions[($ctrl.selectedPurchaseOption)].Amount) {
                $ctrl.marketingDollarsToUse = $ctrl.purchaseOptions[($ctrl.selectedPurchaseOption)].Amount;
            }

            if ($ctrl.marketingDollarsToUse === null || $ctrl.marketingDollarsToUse < 0) {
                $ctrl.marketingDollarsToUse = 0;
            }

            $ctrl.paymentAmount = $ctrl.purchaseOptions[($ctrl.selectedPurchaseOption)].Amount - $ctrl.marketingDollarsToUse;
        }

        function purchase(model) {
            $ctrl.submittingOrder = true;
            var order = { Description: model.Description };
            order.PaymentAmount = $ctrl.paymentAmount;
            order.MarketingDollarsUsed = $ctrl.marketingDollarsToUse;
            order.MarketingStrategy = "RetireUp";
            order.Total = $ctrl.purchaseOptions[$ctrl.selectedPurchaseOption].Amount;
            if ($ctrl.purchaseOptions[$ctrl.selectedPurchaseOption].IsRecurringPayment)
                order.Frequency = 3;
            else
                order.Frequency = 0;

            //need to identify parameters
            return purchaseApi.purchase(order)
                .then(function (response) {

                    $ctrl.submittingOrder = false;
                    close($ctrl.paymentAmount);

                    if ($ctrl.paymentAmount > 0) {
                        $window.open(response, "_blank");
                        //$window.location.href = "/";       
                    }
                });
        }

        function close(paymentAmount) {
            $mdDialog.hide(paymentAmount);
        }

        function cancel() {
            $mdDialog.cancel();
        }
    };
})(window.app, window.angular); // jshint ignore:line